<!--Banner part code-->
<div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel  uk-flex-center uk-flex-middle"
            style="background-image: url(../../assets/businessbanner.png);">
            <div class="uk-section uk-light">
                <div class="uk-container-small uk-width-2xlarge" style="padding-top:30px ;">

                    <h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical">Customized Business Application</h1>

                    <p class="uk-text-text uk-padding-large uk-padding-remove-vertical" style="font-size: 20px;">WebSoulLabs has
                         a broad experience in custom business applications development. We deliver the creative custom 
                         application development services.


                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Banner part code ends-->



<!--Paragraph part code-->
<div class="uk-section uk-padding">
    <div class="uk-container">
        <br>
            <p class="uk-text-medium uk-text-justify" style="font-size: 18px;"> WebSoulLabs has a 
                special infrastructure to make sure that the security of web development is not 
                compromised in any manner. Our main motto is to fulfil the requirements of the 
                clients with our direct support and services.
            </p>
            <p class="uk-text-medium uk-text-justify" style="font-size: 18px;"> To fulfil the requirements 
                of our clients, we have a dedicated team with creative knowledge about web development and 
                provide web services which are reliable & cost-effective. It will be significant to state 
                our devoted team of developers and designers will work in tandem with you to guarantee the 
                best results with a combination of your targets and stipulation.
            </p>
        
</div>
</div>
<!--Paragraph part code ends-->



<!--Column part code-->
<div class="uk-section uk-section-default">
    <div class="uk-container">
        <div class="uk-column-1-2@s">

            <h2 style="font-weight:600">Developing the right Application for your business</h2>
            <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Our technical team performs
                on creating your business to operate easily and accurately. Our dedicated custom application
                development services provide you with absolute solutions from beginning to the development
                of software applications and their installation, training, and maintenance. Our technical
                team takes the proper concern to drop any set of duplicate data. With WebSoulLabs, 
                you can help your business to develop swiftly and create a business release that is
                created on customized software solutions.</p>
            <p class="uk-text-medium uk-text-justify"> <button class=" uk-button uk-button-primary">Know More</button> </p>




            <img data-src="assets/photo3.jpg" width="600" height="600" alt="" uk-img>

        </div>
        <div class="uk-column-1-2@s uk-margin-medium ">
            <img data-src="assets/photo.webp" width="600" height="600" alt="" uk-img>
            <h2 style="font-weight:600">We help you integrate our apps into your solutions </h2>
            <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">WebSoulLabs provides
                web development services in all fields of development from basic to advanced levels.
                It includes server configuration, web design, graphical design, database connection,
                coding of web pages and so on.  We help you to find faster resolutions to any issue,
                and work hard to integrate your feature requests. We value your feedback and we are
                always open to improving our process.</p>
            <p class="uk-text-medium uk-text-justify"><button class=" uk-button uk-button-primary">Know More</button></p>
        </div>
        <div class="uk-column-1-2@s uk-margin-medium ">
            <h2 style="font-weight:600">Create your business on mobile</h2>
            <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Presently, for a small 
                scale business or a big global company, a wide span of mobile business solutions achieves
                all goals of your business exactly as per your objectives. At WebSoulLabs, we deliver a
                wide range of services for the business mobile app development based on the demands of the
                business. Our hi-tech and cost-efficient mobile application development services provide
                businesses with unpaired solutions for the quick growth of their company.</p>
            <p class="uk-text-medium uk-text-justify"><button class=" uk-button uk-button-primary">Know More</button></p>
            <img data-src="assets/pf10.jpeg" width="600" height="600" uk-img>
        </div>
    </div>
</div>
<!--Column part code ends-->




<!--Services part code-->
<div class="uk-container uk-container-expand">
    <div class="ws-services  uk-child-width-1-3@s uk-flex-center uk-light uk-grid-match" uk-grid>
        <h1 class="uk-padding-small uk-align-center">Empowering business through following  Services</h1>
        <div>
            <div class="uk-placeholder uk-text-center uk-panel">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">

                    <img class="uk-border-circle uk-align-center" src="assets/icon.png" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/b2b.jpg"
                        width="68" height="68" alt="">
                </div>
                <h3 style="margin-top: 0px;"><strong>Enterprise Manag App</strong></h3>

               
                <p class="uk-text-text uk-text-justify">We use the most up to date software and technology in creating your Enterprise 

                    Management Application. Our designers and developers are specialized to synergize
                     between their skill and your requirements. 
            </div>
        </div>


        <div>
            <div class="uk-placeholder uk-text-center uk-panel ">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">

                    <img class="uk-border-circle uk-align-center" src="assets/icon.png" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/professional.jpg"
                        width="68" height="68" alt="">
                </div>
                <h3 style="margin-top: 0px;"><strong>Sales Tracker Application</strong></h3>

               

                <p class="uk-text-text uk-text-justify">Nowadays many organizations prefer to use customized sales tracking software solution.

                    Sales app helps to improve your sales team performance and productivity. The advent
                    of sales tracking software.  
                </p>

            </div>
        </div>

        <div>
            <div class="uk-placeholder uk-text-center uk-panel ">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <img class="uk-border-circle uk-align-center" src="assets/icon.png" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/cloud.jpg"
                        width="68" height="68" alt="">
                </div>
                <h3 style="margin-top: 0px;"><strong>Odoo App Development</strong></h3>
                <p class="uk-text-left uk-text-justify">Odoo is the open source resource planning framework which helpful for end-to-end
                    custom business solutions. Applications like CRM, Marketing and Sales, E-commerce,
                    Financial Management, Project Management. 
                </p>

            </div>
        </div>


        <div>
            <div class="uk-placeholder uk-text-center uk-panel">

                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <img class="uk-border-circle uk-align-center" src="assets/icon.png" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/recruitment.jpg"
                        width="68" height="68" alt="border-circle">
                </div>
                <h3 style="margin-top: 0px;"><strong>HR Portal Application</strong></h3>
                <p class="uk-text-left uk-text-justify">Facilitate Human Resource (HR) refines to steer good business solutions. Find the
                    perfect skill, create prospect leaders, and connect all employees with automated,
                    transparent techniques, and digital HR experience.
                </p>

            </div>
        </div>


        <div>

            <div class="uk-placeholder uk-text-center uk-panel">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <img class=" uk-border-circle uk-align-center" src="assets/icon.png" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/job.jpg"
                        width="68" height="68" alt="">
                </div>
                <h3 style="margin-top: 0px;"><strong>Project Management tool</strong></h3>
                <p class="uk-text-left uk-text-justify"> Project Management includes planning, organizing and regulating project actions expected
                    to finish a particular project with the fixed guideline. WebSoulLabs assigns the essential
                    techniques, tools.
                </p>

            </div>
        </div>
        <div>

            <div class="uk-placeholder uk-text-center uk-panel  uk-animation-fast uk-animation-fade">
                <div class="uk-inline-clip uk-transition-toggle" tabindex="0">
                    <img class=" uk-border-circle uk-align-center" src="assets/icon.png" width="68" height="68"
                        alt="border-circle">
                    <img class="uk-border-circle uk-transition-scale-up uk-position-cover" src="assets/wallet.jpg"
                        width="68" height="68" alt="">
                </div>
                <h3 style="margin-top: 0px;"><strong>Accounting Application</strong></h3>
                <p class="uk-text-left uk-text-justify">Accounting software automates a company's economic functions and transactions with modules
                    containing accounts payable, accounts receivable, payroll, billing and general ledger. 
                   
                    
                </p>

            </div>
        </div>
    </div>
</div>
<!--Services part code ends-->




<!--Related Services part code-->
<h1 class="uk-text-center"><span>Related Services</span></h1>
<br>
<div class="uk-container">
    <div class="uk-grid-small uk-child-width-1-4@s  uk-flex-center uk-grid-match" uk-grid>
        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium " style="padding-top: 30px;">

                <img class=" uk-align-center" src="assets/icons/webdeg.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Web Application<br> Development</h4>

            </div>
        </div>


        <div>

            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class="uk-align-center" src="assets/icons/phpg5.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Php Application <br>Development</h4>


            </div>
        </div>


        <div>

            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/laravelg6.png" width="100" height="100"
                    alt="">
                <h4 class="uk-text-center" style="font-weight:600">Laravel Application <br>Development</h4>


            </div>
        </div>

        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class="uk-border-pill uk-align-center" src="assets/icons/cakeg8.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">CakePhp Application<br> Development</h4>


            </div>
        </div>

        <div>

            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class="uk-align-center" src="assets/icons/pythong4.png" width="100" height="100" alt="python">
                <h4 class="uk-text-center" style="font-weight:600">Python Programming<br> Company</h4>


            </div>
        </div>

        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/shopifyg7.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Ecommerce Web<br> Development</h4>


            </div>
        </div>


        <div>
            <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium" style="padding-top: 30px;">
                <img class=" uk-align-center" src="assets/icons/webdesigng12.png" width="100" height="100" alt="">
                <h4 class="uk-text-center" style="font-weight:600">Web Design And<br> Development</h4>

            </div>
        </div>

    </div>

</div>
<!--Related Services part code ends-->



<!--Technology stack part code-->
<br>
<h1 class="uk-text-center"><span>Technology Stack</span></h1>
<br>
<div class="uk-container">
    <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/thsss.jpg" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;">Wordpress</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/angular.png" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;">Angular JS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/post.jpg" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;">Postgres SQL</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/html.jpg" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;">Html</h4>
            </div>
        </div>
    
    
    </div>
    <div class="wss uk-child-width-1-2@s uk-child-width-1-4@m uk-margin-large uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/css-3.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">CSS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/Redis.png" width="130" height="130"
                    alt="border-circle">
                <h4 style="font-weight:600">Redis</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/js-logo.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600" >JavaScript</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/jest.png" style="width:90px; height:90px"
                    alt="border-circle">
                <h4 style="font-weight:600">Jest</h4>
            </div>
        </div>
    </div>
    <div class="wss uk-child-width-1-4@s uk-margin-large uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/logo.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Redux</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/Ruby_logo.png" width="90" height="90"
                    alt="border-circle">
                <h4 style="font-weight:600">Ruby On Rails</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/aws.png" width="130" height="130"
                    alt="border-circle">
                <h4 style="font-weight:600" >AWS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/ng.jpg" width="80" height="80"
                    alt="border-circle">
                <h4 style="font-weight:600">Nginx</h4>
            </div>
        </div>
    </div>
</div>
<br>
<!--Technology stack part code ends-->